import { Container } from '@mui/material';
import { use } from 'chai';
import classNames from 'classnames';
import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { useSelector } from 'react-redux';

import Folded2025Card from '~components/business-owner/Folded2025/components/Folded2025Card';

import { FOLDED_2025_TRACKING_EVENTS } from '~constants/fullstory/events/folded';
import { useBarry } from '~contexts/BarryContext';
import { GlobalState } from '~reducers';
import FullStory from '~third-party/fullstory';

import styles from './Folded2025Finale.module.scss';

type Folded2025FinaleProps = {
	onNavigateAway: (path: string) => void;
};

const Folded2025Finale = (props: Folded2025FinaleProps): JSX.Element => {
	const { barryMessenger } = useFlags();
	const { toggleBarry } = useBarry();
	const { userId, email, business } = useSelector(
		(state: GlobalState) => state?.session,
	);

	return (
		<div className={styles.container}>
			<Container disableGutters>
				<div className={styles.thankYou}>What a year!</div>
				<Folded2025Card style={{ textAlign: 'center' }}>
					<Folded2025Card.Value
						className={classNames(styles.textOverride)}
						size="small"
						font="body"
						style={{ marginBottom: '32px' }}
					>
						We hope you enjoyed seeing your 2025 data perfectly pressed and
						“Folded!”
					</Folded2025Card.Value>
					<Folded2025Card.Value
						className={classNames(styles.textOverride)}
						size="small"
						font="body"
					>
						{barryMessenger ? (
							<>
								Folded is powered by{' '}
								<span className={styles.boldText}>
									Barry, your new business insights AI
								</span>
								. To learn more about any of the metrics from your Folded,
								just{' '}
								<span className={styles.boldText}>
									“Dive in with Barry AI”
								</span>{' '}
								and ask! The power to turn data into dollars is now just a
								conversation away.
							</>
						) : (
							<>
								Folded is powered by{' '}
								<span className={styles.boldText}>
									Barry, our new business insights AI.
								</span>{' '}
								Soon you&apos;ll be able to chat with Barry to get these
								types of metrics yourself. The power to turn data into
								dollars will only be a conversation away! Stay tuned for
								updates.
							</>
						)}
					</Folded2025Card.Value>
				</Folded2025Card>
				{barryMessenger ? (
					<button
						className={styles.ctaButton}
						onClick={() => {
							console.log({ userId, business, email });
							FullStory.event(FOLDED_2025_TRACKING_EVENTS.clickedBarryCta, {
								userId,
								business,
								email,
							});
							props.onNavigateAway('/dashboard/analytics-dashboard');
							// set a short timeout so that it is more obvious that Barry panel is sliding in
							setTimeout(() => {
								toggleBarry();
								// eslint-disable-next-line no-magic-numbers
							}, 500);
						}}
					>
						Dive in with Barry AI
					</button>
				) : (
					<button
						className={styles.ctaButtonBasic}
						onClick={() =>
							props.onNavigateAway('/dashboard/analytics-dashboard')
						}
					>
						Close
					</button>
				)}
			</Container>
		</div>
	);
};

export default Folded2025Finale;
